<button class="e-info-button" [attr.aria-label]="tooltipText" matTooltipClass="e-mat-tooltip" matTooltipPosition="below"
    matTooltip="{{tooltipText}}" matTooltipShowDelay="500">
    <i class="far fa-info-circle"></i>
</button>
